<section fxLayoutAlign="center center">
  <mat-card appearance="outlined" fxFlex="95%">
    @if (!confirmSent) {
      <div>
        <div fxLayout="column" fxLayoutAlign="center center">
          <h1>
            <span class="with-icon">
              <mat-icon>message</mat-icon
                ><span class="pm-send-title">Send A Message</span>
              </span>
            </h1>
            <div fxLayout="row" fxLayoutAlign="center">
              Complete the form below to send a message directly to your
              teacher.
            </div>
          </div>
          <div>
            <send-pm
              (newPm)="sendPm($event)"
              [courses]="courses$ | async"
              (cancel)="onClickCancel()"
              >
            </send-pm>
          </div>
        </div>
      }
      @if (confirmSent) {
        <div>
          <mat-action-row>
            <div
              fxLayout="row"
              fxLayoutAlign="space-between center"
              fxFill
              fxFlex="100"
              >
              <div>Message sent</div>
              <div>
                <button
                  mat-raised-button
                  class="button"
                  type="button"
                  color="primary"
                  (click)="okay()"
                  >
                  Ok
                </button>
              </div>
            </div>
          </mat-action-row>
        </div>
      }
    </mat-card>
  </section>
